export function niceTickStep(range: number, targetTicks: number): number {
  const rough = range / Math.max(1, targetTicks);
  const pow = Math.pow(10, Math.floor(Math.log10(rough)));
  const norm = rough / pow;
  const nice = norm < 1.5 ? 1 : norm < 3 ? 2 : norm < 7 ? 5 : 10;
  return nice * pow;
}

export function formatTick(v: number, step: number): string {
  if (step >= 1) return String(Math.round(v));
  const decimals = Math.max(0, Math.min(6, -Math.floor(Math.log10(step))));
  return v.toFixed(decimals);
}

/** Round up to a "nice" ceiling for y-axis domain. */
export function niceCeil(value: number): number {
  if (value <= 0) return 1;
  const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
  return Math.ceil(value / magnitude) * magnitude;
}

const PI_STEPS = [
  Math.PI / 12,
  Math.PI / 6,
  Math.PI / 4,
  Math.PI / 3,
  Math.PI / 2,
  Math.PI,
  2 * Math.PI,
];

/**
 * π-family tick step: the smallest of π/12, π/6, π/4, π/3, π/2, π, 2π (then 4π,
 * 8π, … doubling) that is ≥ range / targetTicks. Use for axes whose labels are
 * rendered as multiples of π.
 */
export function niceTickStepPi(range: number, targetTicks: number): number {
  const rough = range / Math.max(1, targetTicks);
  for (const step of PI_STEPS) {
    if (step >= rough) return step;
  }
  let step = 2 * Math.PI;
  while (step < rough) step *= 2;
  return step;
}
